/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DebugMonitoringRouteImport } from './routes/debug.monitoring'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedPortalRouteImport } from './routes/_authed/portal'
import { Route as AuthedOrdersRouteImport } from './routes/_authed/orders'
import { Route as AuthedOrderKitRouteImport } from './routes/_authed/order-kit'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugMonitoringRoute = DebugMonitoringRouteImport.update({
  id: '/debug/monitoring',
  path: '/debug/monitoring',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPortalRoute = AuthedPortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrdersRoute = AuthedOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrderKitRoute = AuthedOrderKitRouteImport.update({
  id: '/order-kit',
  path: '/order-kit',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/logout': typeof LogoutRoute
  '/order-kit': typeof AuthedOrderKitRoute
  '/orders': typeof AuthedOrdersRoute
  '/portal': typeof AuthedPortalRoute
  '/settings': typeof AuthedSettingsRoute
  '/users': typeof AuthedUsersRoute
  '/debug/monitoring': typeof DebugMonitoringRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/logout': typeof LogoutRoute
  '/order-kit': typeof AuthedOrderKitRoute
  '/orders': typeof AuthedOrdersRoute
  '/portal': typeof AuthedPortalRoute
  '/settings': typeof AuthedSettingsRoute
  '/users': typeof AuthedUsersRoute
  '/debug/monitoring': typeof DebugMonitoringRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/logout': typeof LogoutRoute
  '/_authed/order-kit': typeof AuthedOrderKitRoute
  '/_authed/orders': typeof AuthedOrdersRoute
  '/_authed/portal': typeof AuthedPortalRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/users': typeof AuthedUsersRoute
  '/debug/monitoring': typeof DebugMonitoringRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/logout'
    | '/order-kit'
    | '/orders'
    | '/portal'
    | '/settings'
    | '/users'
    | '/debug/monitoring'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/logout'
    | '/order-kit'
    | '/orders'
    | '/portal'
    | '/settings'
    | '/users'
    | '/debug/monitoring'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/impersonate'
    | '/logout'
    | '/_authed/order-kit'
    | '/_authed/orders'
    | '/_authed/portal'
    | '/_authed/settings'
    | '/_authed/users'
    | '/debug/monitoring'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
  LogoutRoute: typeof LogoutRoute
  DebugMonitoringRoute: typeof DebugMonitoringRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug/monitoring': {
      id: '/debug/monitoring'
      path: '/debug/monitoring'
      fullPath: '/debug/monitoring'
      preLoaderRoute: typeof DebugMonitoringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/portal': {
      id: '/_authed/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof AuthedPortalRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/orders': {
      id: '/_authed/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthedOrdersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/order-kit': {
      id: '/_authed/order-kit'
      path: '/order-kit'
      fullPath: '/order-kit'
      preLoaderRoute: typeof AuthedOrderKitRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedOrderKitRoute: typeof AuthedOrderKitRoute
  AuthedOrdersRoute: typeof AuthedOrdersRoute
  AuthedPortalRoute: typeof AuthedPortalRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedUsersRoute: typeof AuthedUsersRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedOrderKitRoute: AuthedOrderKitRoute,
  AuthedOrdersRoute: AuthedOrdersRoute,
  AuthedPortalRoute: AuthedPortalRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedUsersRoute: AuthedUsersRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
  LogoutRoute: LogoutRoute,
  DebugMonitoringRoute: DebugMonitoringRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
